/**
 * Video Modal functionality for Colorlines theme
 * Handles opening, closing, and YouTube URL conversion for video modals
 */

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.colorlinesVideoModal = {
    attach: function (context, settings) {
      this.initVideoModal(context);
    },

    initVideoModal: function (context) {
      // Close modal with Escape key
      Drupal.once('video-modal-keyboard', document).forEach(function (element) {
        element.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            Drupal.behaviors.colorlinesVideoModal.closeVideoModal();
          }
        });
      });
    },

    closeVideoModal: function() {
      const modal = document.getElementById('videoModal');
      const iframe = document.getElementById('videoModalIframe');
      
      if (modal) {
        modal.style.display = 'none';
      }
      
      if (iframe) {
        iframe.src = '';
      }

    }
  };

  // Global functions for onclick handlers
  window.openVideoModal = function(element) {
    const videoUrl = element.getAttribute('data-video-url');
    const videoTitle = element.getAttribute('data-video-title');
    const videoDescription = element.getAttribute('data-video-description');
    const projectUrl = element.getAttribute('data-project-url');
    
    // Convert YouTube URL to embed format
    let embedUrl = videoUrl;
    if (videoUrl.includes('youtube.com/watch?v=')) {
      const videoId = videoUrl.split('v=')[1].split('&')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&control=0&loop=1&mw=500&mh=749&q=70`;
    } else if (videoUrl.includes('youtu.be/')) {
      const videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&control=0&loop=1&mw=500&mh=749&q=70`;
    }
    
    // Update iframe source
    const iframe = document.getElementById('videoModalIframe');
    if (iframe) {
      iframe.src = embedUrl;
    }
    
    // Update video title
    const titleElement = document.getElementById('videoModalTitle');
    if (titleElement && videoTitle) {
      titleElement.textContent = videoTitle;
    }
    
    // Update description and Learn More button
    const descriptionElement = document.querySelector('.vid_desc');
    const learnMoreLink = document.getElementById('learnMoreLink');
    const vidInfo = document.getElementById('vidInfo');
    
    // Show/hide vid_info section based on description availability
    if (vidInfo) {
      if (videoDescription && videoDescription.trim() !== '') {
        // Show description and Learn More button
        if (descriptionElement) {
          descriptionElement.textContent = videoDescription;
        }
        if (learnMoreLink && projectUrl) {
          learnMoreLink.href = projectUrl;
        }
        vidInfo.style.display = 'block';
      } else {
        // Hide vid_info section completely
        vidInfo.style.display = 'none';
      }
    }
    
    // Show modal
    const modal = document.getElementById('videoModal');
    if (modal) {
      modal.style.display = 'flex';
      
      // Add click event listener for closing when clicking outside
      // Remove any existing listeners first to prevent duplicates
      modal.removeEventListener('click', handleModalClick);
      modal.addEventListener('click', handleModalClick);
    }
  };

  // Handle clicking outside the modal to close it
  function handleModalClick(e) {
    // Close modal if clicking on the overlay (not the content)
    if (e.target === e.currentTarget) {
      Drupal.behaviors.colorlinesVideoModal.closeVideoModal();
    }
  }

  window.closeVideoModal = function() {
    Drupal.behaviors.colorlinesVideoModal.closeVideoModal();
  };

})(jQuery, Drupal);
